import { MouseEvent, ReactElement } from 'react';
import { PoolLineClampTypography, PoolLink, PoolRow } from '@synergy/components-next';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { DeliveryStatus } from '../../delivery-status/delivery-status';
import { ROUTES } from '../../../utils/routes';
import { useArticleCardContext } from '../article-card';

export const ArticleCardContentSupplierInfo = (): ReactElement => {
    const navigate = useNavigate();
    const { article } = useArticleCardContext();

    const handleClick = (e: MouseEvent): void => {
        e.preventDefault();
        navigate(ROUTES.supplierDirectory.detail.replace(':id', article.supplier.id.toString()));
    };

    return (
        <Stack sx={{ pt: 0.5 }}>
            <PoolRow>
                <PoolLink onClick={handleClick} colorVariant="grey800" as="span">
                    <PoolLineClampTypography variant="caption">{article.supplier.name}</PoolLineClampTypography>
                </PoolLink>
            </PoolRow>
            <DeliveryStatus
                variant="circleSmall"
                deliveryStatus={article.deliveryStatus}
                deliveryTimeInDays={article.deliveryTimeInDays}
            />
        </Stack>
    );
};
